// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import utilities from './utilities'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import qs from 'qs'
import lang from 'vuejs-localization'
import VueLocalStorage from 'vue-localstorage'
import '../src/css/base.css'
import '../node_modules/material-design-icons/iconfont/material-icons.css'
import 'swiper/dist/css/swiper.css'


let VERSION = '1.0.0'

Vue.config.productionTip = false

Vue.use(utilities)
Vue.use(VueAwesomeSwiper)
lang.requireAll(require.context('./lang', true, /\.js$/))
Vue.use(lang)
Vue.use(VueLocalStorage)

Vue.mixin({
  methods: {
    logout: function () {
      this.$store.commit('SET_SHOW_LOGOUT_MODAL', true)
    },
    forceLogin () {
      if (this.userLoggedIn) {
        this.pendingForceLogin = false
      } else {
        if (!this.showLoginModal) {
          if (!this.pendingForceLogin) {
            this.pendingForceLogin = true
            this.$store.commit('SET_SHOW_MODAL', true)
          } else {
            this.pendingForceLogin = false
            this.$router.push({ name: 'Home'})
          }
        }
      }
    }
  },
  computed: {
    showLoginModal () {
      return this.$store.getters.getShowModal
    },
    userLoggedIn () {
      return this.$store.getters.getLoggedIn
    }
  },
  data () {
    return {
      pendingForceLogin: false
    }
  },
  watch: {
    showLoginModal: function () {
      if (this.pendingForceLogin) {
        this.forceLogin()
      }
    }
  },
})

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  beforeCreate () {
    let opts = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    })

    opts.language = 'english'

    if (opts.token && opts.profileId) {
      this.$localStorage.set('token', opts.token)
      this.$localStorage.set('profileId', opts.profileId)
      this.$localStorage.set('username', 'test')
    }

    store.dispatch('INIT', {
      domain: 'bbangstudios.com',
      outlet: 'website',
      version: VERSION,
      opts: opts
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js